import twemoji from "twemoji";
import { highlightAll } from "modules/code-highlight";
import { mountContentItemRunQueryLinks } from "modules/playground-link-for-queries";
import { loadMathjax } from "controllers/mathjax";

let md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true
});
let markdownItAttrs = require("markdown-it-attrs");

let emoji = require("markdown-it-emoji");

md.use(emoji);

md.use(markdownItAttrs, {
  leftDelimiter: "{",
  rightDelimiter: "}",
  allowedAttributes: []
});

md.renderer.rules.emoji = function(token, idx) {
  return twemoji.parse(token[idx].content, {
    base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/'
  });
};

document.querySelectorAll(".js-ai-chat-search-message").forEach(($message) => {
  const datasetId = $message.dataset.datasetId;
  const message = $message.dataset.message;
  const searchTerm = $message.dataset.searchTerm;
  const author = $message.dataset.author;

  // Convert h1-s to h2 to avoid polluting the screen.
  let result = message.replace(/^(#+)\s/gm, (match) => {
    return match.length === 1 ? `##` : match;
  });

  // Make sure AI-messages are highlighted as PostgreSQL.
  // Set dataset id for queries.
  result = result.replaceAll("```sql", `\`\`\` {data-dataset-id=${datasetId}}`);

  if (author === "user") {
    $message.innerHTML = md.renderInline(result);
  } else {
    $message.innerHTML = md.render(result);
  }

  highlightAll();

  // Highlight search_term in the query after highlight JS.
  if (searchTerm) {
    const regex = new RegExp(searchTerm, 'gi');
    $message.innerHTML = $message.innerHTML.replace(regex, match => `<mark class="js-search-term">${match}</mark>`);
  }

  mountContentItemRunQueryLinks();

  loadMathjax();
});
